export default {"src":"/_next/static/media/reddit-share-button-icon.981738d6.svg","height":38,"width":123,"blurWidth":0,"blurHeight":0};